import { z } from 'zod';

import { type BaseItem } from '../common.js';

// Cloned from backend/flow/api/src/models/flowAlertRule/schema.ts

export enum FlowAlertRuleThresholdType {
  Count = 'Count',
  Percentage = 'Percentage',
}

export enum FlowAlertRuleRunMode {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

const BaseFlowAlertRuleSchema = z.object({
  organizationId: z.string(),
  flowId: z.string(),
  displayName: z.string(),
  thresholdType: z.nativeEnum(FlowAlertRuleThresholdType),
  thresholdValue: z.number().nonnegative(),
  windowMinutes: z.number().int().min(1).max(60),
  minSampleSize: z.number().int().min(1),
  cooldownMinutes: z.number().int().min(5),
  runMode: z.nativeEnum(FlowAlertRuleRunMode),
  recipients: z.array(z.string().email()),
});

export type FlowAlertRule = z.infer<typeof BaseFlowAlertRuleSchema> & BaseItem;

export const CreateFlowAlertRuleSchema = BaseFlowAlertRuleSchema.omit({ runMode: true }).extend({
  runMode: z.nativeEnum(FlowAlertRuleRunMode).optional(),
});
export type CreateValues = z.infer<typeof CreateFlowAlertRuleSchema>;

export const UpdateFlowAlertRuleSchema = BaseFlowAlertRuleSchema.omit({
  organizationId: true,
  flowId: true,
}).partial();
export type UpdateValues = z.infer<typeof UpdateFlowAlertRuleSchema>;

export const FindAllOptionsSchema = z.object({
  organizationId: z.union([z.string(), z.array(z.string())]).optional(),
  flowId: z.string().optional(),
  runMode: z
    .union([z.nativeEnum(FlowAlertRuleRunMode), z.array(z.nativeEnum(FlowAlertRuleRunMode))])
    .optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
});
export type FindAllOptions = z.infer<typeof FindAllOptionsSchema>;
